import React, { useState} from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Register.css";
import Spinner from "../Components/Spinner";
import shinelogo from './images/shinelogo.svg';
import { registerUser } from "../config/api";

const Register = () => {
  const [loader, setLoader] = useState("none");
  const [user, setUser] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const toastOptions = {
    position: "top-right",
    autoClose: 8000,
    pauseOnHover: true,
    draggable: true,
    theme: "dark",
  };


  const handleInputs = (event) => {
    setUser({ ...user, [event.target.name]: event.target.value });
  };

  const handleValidation = () => {
    const { password, confirmPassword, username, email } = user;
    if (password !== confirmPassword) {
      toast.error(
        "password and confirm password should be same.",
        toastOptions
      );
      return false;
    } else if (username.length <= 2) {
      toast.error("Enter your full name", toastOptions);
      return false;
    } else if (password.length < 6) {
      toast.error("Password should be greater than 6 character", toastOptions);
      return false;
    } else if (email === "") {
      toast.error("Email is required", toastOptions);
      return false;
    }
    return true;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const { username, email, password } = user;
    const requestOptions = {
      username,
      email,
      password,
    };

    if (handleValidation()) {
      setLoader("flex");
      const data = await registerUser(requestOptions);
      if (data) {
        setLoader("none");
      }
      console.log(data);
      if (data.status === 201) {
        toast.success(data.data.message, toastOptions);
      }
      else {
      toast.error(data.response.data.error, toastOptions);
      }
    }
  };

  return (
    <>
      <div className="register_form_section">
        <FormContainer className="form_container_register">
          <form
            className="register_u_form"
            method="POST"
            onSubmit={PostData}
            data-aos="fade-right"
          >
            <div className="brand">
            <img src={shinelogo} alt="logo" />
            </div>
            <input
              type="text"
              placeholder="Enter Your Name"
              name="username"
              value={user.username}
              onChange={handleInputs}
              autoComplete="off"
            />
            <input
              type="email"
              placeholder="Email"
              name="email"
              value={user.email}
              onChange={handleInputs}
              autoComplete="off"
            />
            <input
              type="Password"
              placeholder="Password"
              name="password"
              value={user.password}
              onChange={handleInputs}
              autoComplete="off"
            />
            <input
              type="Password"
              placeholder="Confirm Password"
              name="confirmPassword"
              value={user.confirmPassword}
              onChange={handleInputs}
              autoComplete="off"
            />
            <button className="submit_register_btn" type="submit">
              Sign Up
              <Spinner id="rg_loder" style={loader} />
            </button>
            <span className="lower_title_register">
              Already have an account ?<Link to="/login_user">Login</Link>
            </span>
          </form>
        </FormContainer>
        <ToastContainer />
      </div>
    </>
  );
};

const FormContainer = styled.div``;

export default Register;
